import React from 'react';
import { css } from 'linaria';
import { SeasonStartCollections } from '../../../components/season-start-collections';
import { SeasonStartCategory } from '../../../components/season-start-category';
import { SeasonStartCategoriesContainer } from '../../../components/season-start-categories';
import { SEASON_START_KITCHEN_CDN_PATH, SEASON_START_KITCHEN_ELEMENT_BLOCK } from '../../kitchen-page-constants'

const collectionSlider = css`
  && {
    > div {
      @media (--from-desktop) {
        grid-template-columns: 1fr 1fr;
        row-gap: 16px;
      }
    }
  }
`;

export const KitchenPageCategories = () => (
  <SeasonStartCategoriesContainer>
    <SeasonStartCollections
      sliderClassName={collectionSlider}
      elementBlock={SEASON_START_KITCHEN_ELEMENT_BLOCK}
      division='Кухни'
      subdivision='Готовые комплекты'
      collectionList={[
        {
          discount: 0.15,
          productId: 12111118,
          title: 'Гарнитур «Миус»',
          description: 'Прямой и угловой, 120–240 см',
          img: {
            src: `${SEASON_START_KITCHEN_CDN_PATH}/collections/mius.jpg/mius-01.jpg`,
            alt: 'Фото гарнитура Миус',
          },
          href: '/proekt-kuhni/gotovye/pryamye/kuhonnyy-garnitur-mius-12-m/',
        },
        {
          discount: 0.1,
          productId: 12111121,
          title: 'Гарнитур «Нарбус»',
          description: 'Прямой и угловой, 120–240 см',
          img: {
            src: `${SEASON_START_KITCHEN_CDN_PATH}/collections/narbus.jpg/narbus-01.jpg`,
            alt: 'Фото гарнитура Нарбус',
          },
          href: '/proekt-kuhni/gotovye/pryamye/kuhonnyy-garnitur-narbus-12-m/',
        },
        {
          discount: 0.1,
          productId: 12111120,
          title: 'Гарнитур «Парма»',
          description: 'Прямой, 120–240 см',
          img: {
            src: `${SEASON_START_KITCHEN_CDN_PATH}/collections/parma.jpg/parma-01.jpg`,
            alt: 'Фото гарнитура Парма',
          },
          href: '/proekt-kuhni/gotovye/pryamye/kuhonnyy-garnitur-parma-12-m/',
        },
        {
          discount: 0.1,
          productId: 12111119,
          title: 'Гарнитур «Лача»',
          description: 'Прямой и угловой, 120–240 см',
          img: {
            src: `${SEASON_START_KITCHEN_CDN_PATH}/collections/lacha.jpg/lacha-01.jpg`,
            alt: 'Фото гарнитрура Лача',
          },
          href: '/proekt-kuhni/gotovye/pryamye/kuhonnyy-garnitur-lacha-12-m/',
        },
      ]}
      showAllLink={{
        href: '/proekt-kuhni/gotovye/',
        title: 'Готовые комплекты кухонь',
      }}
    />
    <SeasonStartCategory
      elementBlock={SEASON_START_KITCHEN_ELEMENT_BLOCK}
      category={{
        discountBableSrc: `${SEASON_START_KITCHEN_CDN_PATH}/categories/discount-babel.png/discount-babel.png`,
        title: 'Все для кухни',
        img: {
          className: css`
            @media (--only-largeDesktop) {
              height: 670px;
            }

            @media (--only-desktop) {
              height: 621px;
            }

            @media (--only-tablet) {
              height: 660px;
            }

            @media (--only-mobile) {
              height: 450px;
            }
          `,
          srcLd: `${SEASON_START_KITCHEN_CDN_PATH}/categories/kitchen-bg-ld.jpg/kitchen-bg-ld.jpg`,
          srcD: `${SEASON_START_KITCHEN_CDN_PATH}/categories/kitchen-bg-d.jpg/kitchen-bg-d.jpg`,
          srcT: `${SEASON_START_KITCHEN_CDN_PATH}/categories/kitchen-bg-t.jpg/kitchen-bg-t.jpg`,
          src: `${SEASON_START_KITCHEN_CDN_PATH}/categories/kitchen-bg-m.jpg/kitchen-bg-m.jpg`,
        },
        itemList: [
          {
            href: '/offer/pora-pora-za-bytovoy-tehnikoy-dlya-kuhni-po-supercenam',
            img: {
              alt: 'Изображение электрического чайника',
              src: `${SEASON_START_KITCHEN_CDN_PATH}/categories/household-appliances.jpg/household-appliances.jpg`,
            },
            title: 'Бытовая техника',
          },
          {
            href: '/offer/pora-pora-za-mebelyu-dlya-kuhni-po-supercenam',
            img: {
              alt: 'Изображение кухонного шкафа',
              src: `${SEASON_START_KITCHEN_CDN_PATH}/categories/furniture.jpg/furniture.jpg`,
            },
            title: 'Мебель',
          },
          {
            href: '/offer/pora-pora-za-aksessuarami-dlya-kuhni-po-supercenam',
            img: {
              alt: 'Изображение разделочной доски',
              src: `${SEASON_START_KITCHEN_CDN_PATH}/categories/accessories.jpg/accessories.jpg`,
            },
            title: 'Аксессуары',
          },
        ],
      }}
    />
  </SeasonStartCategoriesContainer>
);
